export default __webpack_public_path__ + "ddfcd81e3afbfb6aad08baadaefa2c48.ttf";